/** @flow */
import { reduxForm } from 'redux-form/immutable';


export default reduxForm;
